/**
 *
 * Asynchronously loads the component for AllowList
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AllowList = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.AllowList,
);
